<template>
  <div class="w-11/12 mx-auto mt-16">
     <p v-html="student.bio" class="text-left font-sans-serif text-base md:text-lg border-l-4 pl-4
      border-orange-academy-150" />
    <div class="flex flex-col mt-10 w-full">
      <div v-if="schools.length>0">
        <p class="border-b-2 border-grey-academy-150 text-xl text-orange-academy-300
        font-bold mb-6 mt-6 uppercase pl-2">
          {{ $t('student.studies') }}
        </p>
        <school-row
          v-for="school in schools"
          :key="school.id"
          :school="school"/>
      </div>
      <div class="mt-16 w-full" v-if="instruments.length>0">
        <p class="border-b-2 border-grey-academy-150 text-xl text-orange-academy-300
        font-bold mb-6 pl-2 uppercase">
          {{ $t('student.instruments') }}
        </p>
        <instrument-row
          v-for="instrument in instruments"
          :key="instrument.id"
          :instrument="instrument" />
      </div>
    </div>
  </div>
</template>

<script>
import { getStudentBySlug, getStudentSchools, getStudentInstruments } from '@/services/StudentService';
import InstrumentRow from '../InstrumentRow.vue';
import SchoolRow from '../SchoolRow.vue';

export default {
  components: { InstrumentRow, SchoolRow },

  data() {
    return {
      student: {},
      schools: [],
      instruments: [],
    };
  },

  created() {
    getStudentBySlug(this.$route.params.slug).then(({ data }) => {
      this.student = data;
      this.getSchools();
      this.getInstruments();
    });
  },

  methods: {
    getSchools() {
      getStudentSchools(this.student.user.id).then(({ data }) => {
        this.schools = data;
      });
    },

    getInstruments() {
      getStudentInstruments(this.student.id).then(({ data }) => {
        this.instruments = data;
      });
    },
  },
};
</script>
